import { ThumbnailRenderer } from "src/types/ThumbnailRenderer";
import type { RgWorld } from "src/types/RgCorePackage";

// Render an RgWorld at an arbitrary camera direction and size, returning a
// data URL. Uses the same ThumbnailRenderer the design-generator worker uses
// for its small worker-side preview. camDir [1, -1, 1] gives an isometric
// view; [0, -1, 0] is top-down (the worker default).
//
// `frame` controls what the camera fits: "zones" (default) frames the entire
// site polygon; "buildings" frames only the building footprints so the
// buildings fill the image. Falls back to zones if no buildings exist.
export async function RenderRgWorld(
  rgWorld: RgWorld,
  camDir: [number, number, number],
  size: number,
  frame: "zones" | "buildings" = "zones"
): Promise<string> {
  const canvas = new OffscreenCanvas(size, size);
  const renderer = new ThumbnailRenderer();
  renderer.init(canvas);
  try {
    await renderer.render({
      rgWorld,
      camDir,
      height: size,
      orthographic: true,
      width: size,
      frame,
    });
    const blob = await renderer.canvas.convertToBlob();
    return await new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  } finally {
    // Free the WebGL context — without this a multi-design report exhausts the
    // browser's context limit and later renders fail.
    renderer.dispose();
  }
}
